const TransportationDbConstants = {
  validTransportationDbHeaders: {
    Sku: 'sku',
    'Transportation Mode': 'transport_mode',
    'Max Quantity': 'max_quantity',
    Category: 'category',
    'Package Details': 'pkg_detail',
    'Volume kg': 'volume_kg',
    'Volume ltr': 'volume_ltr',
  },
  validOptionalTransportationDbHeaders: {
    'Service Code': 'service_code',
    'Content Id': 'content_id',
    'Inner quantity': 'inner_quantity',
  },
};

module.exports = { TransportationDbConstants };
